import React, { useState, useCallback } from 'react'
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import { StVideoProportion, StVideo, StVideoSticky } from './style.css'

const useClientRect = () => {
  const [rect, setRect] = useState(null)
  const ref = useCallback(node => {
    if (node !== null) {
      setRect(node.getBoundingClientRect())
    }
  }, [])
  return [rect, ref]
}

const Video = ({ video }) => {
  const isBrowser = typeof window !== `undefined`

  const [isScrolled, setIsScrolled] = useState(false)
  const [rect, ref] = useClientRect()

  const { description, iframe, title } = video

  const htmldescription = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(description)
    .toString()

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (rect.bottom < -currPos.y !== isScrolled) {
        setIsScrolled(rect.bottom < -currPos.y)
      }
    },
    [rect, setIsScrolled, isScrolled],
  )

  return (
    <div className="mx-auto text-left">
      <div className="bg-white">
        <div className="asdf" ref={ref}>
          <StVideoProportion>
            <StVideoSticky className={`${isScrolled ? 'isScrolled' : ''}`}>
              <StVideo className="video-wrapper">
                <div
                  className="iframe-wrap"
                  dangerouslySetInnerHTML={{ __html: iframe }}
                />
              </StVideo>
              <div className="info-wrapper">
                <h1 className="leading-none sm:mb-4 text-sm font-bold sm:text-4xl">
                  {title}
                </h1>
                <p className="">
                  {/* <span className="font-bold text-xs sm:text-sm leading-none">
                    {title}
                  </span> */}
                  {htmldescription && (
                    <small
                      className="block text-xs sm:text-sm leading-none"
                      dangerouslySetInnerHTML={{
                        __html: htmldescription,
                      }}></small>
                  )}
                </p>
              </div>
            </StVideoSticky>
            <span className="heighter"></span>
          </StVideoProportion>
        </div>
      </div>
    </div>
  )
}

export default Video
